import { Box, Grid } from "@material-ui/core";
import { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { ChangeShowNavigation } from "../../Store/Slices/CommonDataSlice";
import { mainContentStyle } from "./mainContentStyle";
import SectionOne from "./SectionOne";

const MovieSection = () => {
  const classes = mainContentStyle();
  const history = useHistory();
  const [playVideo, setPlayVideo] = useState(false);
  const [scrollPosition, setScrollPosition] = useState<any>(0);
  const [showNavigation, setShowNavigation] = useState<any>(true);
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  var userAgent = navigator.userAgent;

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }
  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {}, [windowDimensions]);

  const dispatch = useDispatch();

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY === 0) {
        var section1: any = document.getElementById("section_one_id");
        if (!!section1) {
          section1.scrollTo(0, 0);
        }
      }
    });
  }, [window.scrollY]);
  useEffect(() => {
    setTimeout(() => {
      setPlayVideo(true);
    }, 2000);
    setTimeout(() => {
      document.getElementById("main_text_id")?.classList.add("fadeIn");
    }, 1000);
  }, []);

  return (
    <>
      <Box
        id="movie_section_id"
        className={classes.secOneCntnr}
        sx={{
          maxHeight: {
            xs: "200vh",
            sm: "200vh",
            md: "100vh",
            lg: "100vh",
          },
          height: { xs: "", sm: "", md: "1000px", lg: "1000px" },
        }}
      >
        {/* <div style={{ position: "absolute", top: "300px", right: "100px" }}>
      <div className="progress-containter">
        <div className="progress-bar" id="myBar"></div>
      </div>
    </div> */}
        <Box
          onScroll={(event: any) => {
            const secOne = document.getElementById("section_one_id")?.scrollTop;
            if (!!secOne)
              if (scrollPosition >= secOne) {
                setScrollPosition(secOne);
                if (!showNavigation) {
                  setShowNavigation(true);
                  dispatch(ChangeShowNavigation(true));
                }
              } else {
                setScrollPosition(secOne);
                if (showNavigation) {
                  setShowNavigation(false);
                  dispatch(ChangeShowNavigation(false));
                }
              }
          }}
          sx={{
            height: { xs: "auto", sm: "auto", md: "100vh", lg: "100vh" },
            paddingTop: {
              xs: "-100px",
              sm: "-100px",
              md: "-130px",
              lg: "-130px",
            },
          }}
          style={{
            overflowY:
              /android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent)
                ? "hidden"
                : "auto",
          }}
          id="section_one_id"
          className={classes.secOne}
        >
          <Box
            sx={{
              marginTop: { xs: "120px", sm: "120px", md: "50px", lg: "50px" },
              height: "100vh",
              width: "100vw",
            }}
            style={{ direction: "rtl", overflowY: "auto" }}
            className={classes.video}
          >
            <ReactPlayer
              autoPlay
              loop
              muted
              playsinline
              width="100%"
              height="auto"
              playing={playVideo}
              url={process.env.PUBLIC_URL + "/videos/main.mp4"}
            />
          </Box>
          <Box
            className={classes.mainHeader}
            sx={{
              lineHeight: { xs: "40px", sm: "40px", md: "40px", lg: "40px" },
              color: {
                lg: "#ffffffb8",
                md: "#ffffffb8",
                sm: "black",
                xs: "black",
              },
              marginTop: { xs: "350px", sm: "200px", md: "350px", lg: "350px" },
              position: "absolute",
              top: { xs: "50px", sm: "20%", md: "15%", lg: "15%" },
            }}
            style={{ direction: "rtl" }}
          >
            <div className="main-text" id="main_text_id">
              <Grid item lg={6} md={12} sm={12} xs={12}>
                <Box
                  className="row justify-content-center w-100 ml-0 mr-0"
                  sx={{
                    fontSize: {
                      xs: "16px",
                      sm: "16px",
                      md: "24px",
                      lg: "24px",
                    },
                    fontWeight: 900,
                  }}
                >
                  <span className={classes.shadowText}>
                    پلتفـــرم اختصاصی خرید و فروش آنلاین خودروهای کرمان موتور
                  </span>
                </Box>
                <Box
                  className="row justify-content-center w-100 ml-0 mr-0"
                  sx={{
                    marginTop:
                      windowDimensions.width > windowDimensions.height &&
                      windowDimensions.width < 1000
                        ? "2rem"
                        : "3rem",
                    fontSize: {
                      xs: "16px",
                      sm: "16px",
                      md: "24px",
                      lg: "24px",
                    },
                    fontWeight: 900,
                  }}
                  style={{ fontWeight: 900 }}
                >
                  <span className={classes.shadowText}>
                    صفــــر و کــــارکرده
                  </span>
                </Box>
                <Box
                  className="row justify-content-center w-100 ml-0 mr-0"
                  sx={{
                    marginTop:
                      windowDimensions.width > windowDimensions.height &&
                      windowDimensions.width < 1000
                        ? "2rem"
                        : "3rem",
                    fontSize: {
                      xs: "16px",
                      sm: "16px",
                      md: "24px",
                      lg: "24px",
                    },
                    fontWeight: 900,
                  }}
                  style={{ fontWeight: 900 }}
                >
                  <Box
                    sx={{
                      marginTop: { xs: "60px", sm: "0", md: "0", lg: "0" },
                    }}
                    className={classes.ad}
                  >
                    <div
                      style={{
                        display: "table-cell",
                        verticalAlign: "middle",
                        color: "white",
                      }}
                      onClick={() => history.push("/purchase-order")}
                    >
                      مشاهــده آگـهـی هـا
                    </div>
                  </Box>
                </Box>
              </Grid>
            </div>
          </Box>
          {!(
            /android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent)
          ) && (
            <Box
              style={{
                position:
                  /android/i.test(userAgent) ||
                  /iPad|iPhone|iPod/.test(userAgent)
                    ? "sticky"
                    : "absolute",
                width: "100%",
                top:
                  /android/i.test(userAgent) ||
                  /iPad|iPhone|iPod/.test(userAgent)
                    ? "0"
                    : document.getElementById("movie_section_id")?.offsetHeight,
                marginTop: showNavigation ? 130 : 70,
              }}
            >
              <SectionOne />
            </Box>
          )}
        </Box>
      </Box>
      {(/android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent)) && (
        <Box
          style={{
            width: "100%",
            minHeight: "400px",
          }}
        >
          <SectionOne />
        </Box>
      )}
    </>
  );
};

export default MovieSection;
